import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AddHearingForm from './AddHearingForm'; // Correct import for your AddHearingForm

function HearingsTab({ caseId }) {
  const [hearings, setHearings] = useState([]); // State to store hearings data
  const [showForm, setShowForm] = useState(false); // State to toggle form visibility

  // Fetch hearings based on the caseId passed as a prop
  const fetchHearings = async () => {
    const token = localStorage.getItem("token");

    try {
      const res = await axios.get(`${process.env.REACT_APP_BACKEND_URL}/api/hearings/by-case/${caseId}`,{
        headers: {
          Authorization: `Bearer ${token}`,
        },
        withCredentials: true,
      });
      setHearings(res.data); // Set fetched hearings to the state
    } catch (error) {
      console.error('Error fetching hearings:', error);
    }
  };

  // Run fetchHearings whenever caseId changes or the component mounts
  useEffect(() => {
    if (caseId) fetchHearings(); // Fetch hearings only if caseId is available
  }, [caseId]);

  // Delete a hearing by ID
  const handleDelete = async (id) => {
    if (window.confirm("Are you sure you want to delete this hearing?")) {
      try {
        await axios.delete(`${process.env.REACT_APP_BACKEND_URL}/api/hearings/${id}`);
        alert("Hearing deleted.");
        fetchHearings();  // Refresh the hearings list after deletion
      } catch (err) {
        console.error("Error deleting hearing:", err);
        alert("Failed to delete hearing.");
      }
    }
  };

  return (
    <div className="space-y-4">
   

      <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4">
        {hearings.map((hearing) => (
          <div
            key={hearing._id}
            className="bg-white p-4 border rounded shadow flex justify-between items-start"
          >
            <div>
              <h3 className="text-lg font-bold">{hearing.caseTitle}</h3>
              <p><strong>Date:</strong> {new Date(hearing.date).toLocaleDateString()}</p>
              <p><strong>Reminder:</strong> {hearing.reminder ? 'Yes' : 'No'}</p>
              <p><strong>Notes:</strong> {hearing.notes || '—'}</p>
            </div>

           
          </div>
        ))}
      </div>
    </div>
  );
}

export default HearingsTab;
